import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommTableFooter from './EcommTableFooter';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDataReadOnlyRow from './EcommDataReadOnlyRow';
import EcommDataNumberRow from './EcommDataNumberRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import EcommDataProductTierRow from './EcommDataProductTierRow';

class EcommDataTranslationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      translationData: {
        ...props.translationData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const keyValues = { [name]: value };
    const { saveOne, translationLanguage } = this.props;
    this.setState(prevState => ({
      translationData: {
        ...prevState.translationData,
        [key]: {
          ...prevState.translationData[key],
          [name]: value
        }
      }
    }));
    if (value || value === 0) {
      const { translationData } = this.state;
      saveOne({
        date: translationData[key].date,
        locationType: 'translation',
        locationId: translationData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000,
        translationLanguage
      });
    }
  };

  handleSpecialProjectChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne, translationLanguage } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(prevState => ({
      translationData: {
        ...prevState.translationData,
        [key]: {
          ...prevState.translationData[key],
          [name]: projectName,
          isSpecialProject,
        }
      }
    }),
    () => {
      const { translationData } = this.state;
      saveOne({
        date: translationData[key].date,
        locationType: 'translation',
        locationId: translationData[key].locationId,
        keyValues,
        updatedAt: new Date().getTime() / 1000,
        translationLanguage
      })
    });
  };

  getTabIndex = (column)=> {
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { translationData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      studioItemCount,
      specialProjectOptions,
      canEdit,
      translationLanguage
    } = this.props;
    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey={`${translationLanguage}TranslationTitle`}
            tableTitle={i18n.t(`location:${translationLanguage}TableTitle`)}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(translationData).map(element =>
                translationData[element].translationLocationName)}
            />
            <EcommDataReadOnlyRow
              title={i18n.t('location:items').toUpperCase()}
              valueToDisplay={studioItemCount}
            />
            <EcommDataNumberRow
              getTabIndex={this.getTabIndex}
              key={i18n.t('location:additionalItems').toUpperCase()}
              canEdit={canEdit}
              handleChange={this.handleChange}
              locationData={translationData}
              rowTitle={i18n.t('location:additionalItems').toUpperCase()}
              valueKey="additionalItems"
            />
            <EcommDataSpecialProjectRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={translationData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            <EcommDataProductTierRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={translationData}
              handleChange={this.handleChange}
            />
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataTranslationTable.propTypes = {
  translationData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  studioItemCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  translationLanguage: PropTypes.string.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  saveOne: PropTypes.func.isRequired,
  startTabIndex: PropTypes.number,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
};

EcommDataTranslationTable.defaultProps = {
  startTabIndex: 700
}

export default EcommDataTranslationTable;
